import { CustomThemeKeys } from "../../theme";
import React from "react";
import { appThemeQueryOptions } from "@/api/cache/appThemeQueryOptions";
import { useQuery } from "@tanstack/react-query";

interface OutlineButtonProps {
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const OutlineButton: React.FC<OutlineButtonProps> = ({ children, onClick }) => {
  const { data: styleData } = useQuery(appThemeQueryOptions());

  const globalButtonRadius = styleData?.globalButtonRadius;
  const customTheme =
    styleData?.componentStyleOverrides?.[CustomThemeKeys.OUTLINED_BUTTON];

  const borderColor = customTheme?.tertiary;
  const color = !!customTheme?.enabled
    ? customTheme?.primary
    : styleData?.primary;
  const cap = !!customTheme?.enabled
    ? customTheme?.capitalize
      ? "uppercase"
      : "none"
    : "none";

  return (
    <button
      type="button"
      className={`bc-h-[46px] bc-min-w-0 desktop:bc-h-[52px] bc-w-fit bc-cursor-pointer bc-box-border disabled:bc-cursor-not-allowed bc-border bc-border-solid bc-bg-white hover:!bc-bg-white bc-medium-adjust-text bc-font-medium bc-px-[12px] desktop:bc-px-[20px] bc-whitespace-nowrap`}
      onClick={onClick}
      style={{
        borderColor: borderColor ?? "#dcdddc",
        color: color,
        textTransform: cap,
        borderRadius: globalButtonRadius,
      }}
    >
      {children}
    </button>
  );
};

export default OutlineButton;
